export function normalizeStoredModules(value) {
  try {
    const parsed = typeof value === "string" ? JSON.parse(value) : value;
    const modules = Array.isArray(parsed) ? parsed : parsed?.modules;
    return Array.isArray(modules) ? modules.map((module) => String(module || "").trim().toLowerCase()) : [];
  } catch (_error) {
    return [];
  }
}

export function hasAnyModule(storedModules, requiredModules) {
  const modules = normalizeStoredModules(storedModules);
  return requiredModules.some((module) => modules.includes(String(module).toLowerCase()));
}
